export const DRAWER_WIDTH = 230;
export const DRAWER_WIDTH_CLOSED = 60;
